import { useEffect, useState } from 'react'
import { Stack, Button } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import EhqJSON from '../Templates/ehq.json'
import MultiSelectFilter from './MultiSelectFilter'
import FilterMenu from './FilterMenu'
import { resetUserFilters } from 'redux/slices/TextAnalysis'
import { FilterType, OwnerType, SourceType, Template } from './Helper'

const AddOrRemoveFilter = () => {
  const {
    allContributions: { fetching },
  } = useAppSelector((state) => state.textAnalysis)

  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const [originalTemplate, setOriginalTemplate] = useState<Template | null>(
    null,
  )
  const [template, setTemplate] = useState<Template | null>(null)
  const [disableClearAllFilters, setDisableClearAllFilters] =
    useState<boolean>(true)

  const sourceType = searchParams.get('source_type') as SourceType
  const ownerType = searchParams.get('owner_type') as OwnerType

  useEffect(() => {
    const templateConfig = {
      ehq: {
        template: sourceType ? EhqJSON[ownerType] ?? null : null,
      },
    }

    const selectedTemplate = (
      sourceType ? templateConfig[sourceType]['template'] : null
    ) as Template | null

    setOriginalTemplate(selectedTemplate)
    setTemplate(selectedTemplate)
  }, [sourceType, ownerType])

  if (template === null) return null

  const handleFilterSelect = (filter: FilterType) => {
    setTemplate({
      ...template,
      filters: {
        ...template.filters,
        [filter]: {
          ...template.filters[filter],
          visible: true,
        },
      },
    })
    setDisableClearAllFilters(false)
  }

  return (
    <>
      {Object.keys(template.filters).map((filter) => {
        const { visible } = template.filters[filter as FilterType]

        if (!visible) return null

        return (
          <MultiSelectFilter
            key={filter}
            {...template.filters[filter as 'question']}
          />
        )
      })}
      <Stack spacing={2} direction="row" justifyContent="space-between">
        <FilterMenu
          filters={template.filters}
          onFilterSelect={handleFilterSelect}
        />
        <Button
          size="small"
          id="clearFilter"
          disabled={fetching || disableClearAllFilters}
          onClick={() => {
            dispatch(resetUserFilters())
            setTemplate(originalTemplate)
            setDisableClearAllFilters(true)
          }}
        >
          CLEAR ALL
        </Button>
      </Stack>
    </>
  )
}

export default AddOrRemoveFilter
